import { FILTER_TYPES } from 'components/FilterPod';

const GRANT = [
  {
    label: 'درخواست شده',
    value: 'FINANCIAL_PERMISSION_STATUS_REQUESTED',
  },
  {
    label: 'تایید شده',
    value: 'FINANCIAL_PERMISSION_STATUS_CONFIRMED',
  },
  {
    label: 'لغو شده',
    value: 'FINANCIAL_PERMISSION_STATUS_REVOKED',
  },
  {
    label: 'رد شده',
    value: 'FINANCIAL_PERMISSION_STATUS_REJECTED',
  },
  {
    label: 'حذف شده',
    value: 'FINANCIAL_PERMISSION_STATUS_DELETED',
  },
];

const filters = (getAccounts) => [
  {
    title: 'براساس وضعیت مجوز',
    label: 'وضعیت مجوز',
    keyName: 'grantStatus',
    id: 0,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: GRANT,
    },
  },

  {
    title: 'براساس شناسه اعطا کننده مجوز',
    label: 'شناسه اعطا کننده مجوز',
    keyName: 'ownerUserId',
    id: 0,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: false },
  },
  {
    title: 'براساس شناسه ایجاد کننده مجوز',
    label: 'شناسه ایجاد کننده مجوز',
    keyName: 'creatorUserId',
    id: 0,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: false },
  },
];

export default filters;
